import { IRoleDTO, IRoleWithPermissionSetsDTO } from 'app/shared/services/role.service';
import { Permissionset } from 'app/shared/models/permissionset';
import { RoleKey } from 'app/shared/models/keys/role-key';
import { Entity } from '@kpd/framework-ngx';

export interface IRole {
  isAssignedByDefault: boolean;
  name: string;
  permissionSets?: Permissionset[];
  description: {
    dutch?: string;
    english?: string;
    french?: string;
    german?: string;
  };
}

export class Role extends Entity {
  key: RoleKey;
  isAssignedByDefault: boolean;
  name: string;
  description: {
    dutch?: string;
    english?: string;
    french?: string;
    german?: string;
  };
  permissionSets?: Permissionset[];
  application?: string;

  constructor(dto?: IRoleDTO, application?: string) {
    super();
    Object.assign(this, dto);
    this.application = application;
    if (dto) {
      this.setKey();
      const dtoWithPermissionSets = dto as IRoleWithPermissionSetsDTO;
      if (dtoWithPermissionSets && dtoWithPermissionSets.permissionSets) {
        this.permissionSets = dtoWithPermissionSets.permissionSets.map(set => new Permissionset(set, application));
      }
    }
    if (!this.description) {
      this.description = {};
    }
  }

  getDisplayName(): string {
    if (!this.name) {
      return '';
    }
    let displayName = this.name;
    if (this.application) {
      displayName += ` - ${this.application}`;
    }
    return displayName;
  }

  setKey(): void {
    this.key = new RoleKey(this.name, this.application || '');
  }

  clone(): Role {
    const clone = new Role();
    Object.assign(clone, this);
    return clone;
  }

  isNew(): boolean {
    return !this.key;
  }
}
